import {GitHubAvatar} from '@github-ui/github-avatar'
import {testIdProps} from '@github-ui/test-id-props'
import {useClickAnalytics} from '@github-ui/use-analytics'
import {IconButton, Spinner} from '@primer/react'

import {analyticsCategory} from './constants'
import styles from './GlobalNavUserMenu.module.css'

export function GlobalNavUserMenuToggle({
  owner,
  ref,
  open,
  setOpen,
  isLoading,
}: {
  owner: {
    login: string
    name: string
    avatarUrl: string
  }
  ref?: React.Ref<HTMLButtonElement>
  open: boolean
  setOpen: (open: boolean) => void
  isLoading?: boolean
}) {
  const {sendClickAnalyticsEvent} = useClickAnalytics()

  const label = `${open ? 'Close' : 'Open'} user navigation menu`
  return (
    <div className={styles.container}>
      <IconButton
        ref={ref}
        className={styles.anchor}
        variant="invisible"
        icon={() => <GitHubAvatar size={32} alt={owner.name ?? 'User avatar'} src={owner.avatarUrl} />}
        aria-label={label}
        aria-haspopup="menu"
        onClick={() => {
          setOpen(!open)
          sendClickAnalyticsEvent({category: analyticsCategory, action: 'USER_NAV_MENU_TOGGLE', label})
        }}
        data-login={owner.login}
        {...testIdProps('global-nav-user-menu-toggle')}
      />
      {isLoading && open && (
        <div className={styles.overlay}>
          <Spinner size="small" />
        </div>
      )}
    </div>
  )
}
